export default __webpack_public_path__ + "static/fresh-pets-open-graph-27ec8869638d01ff904835487601cd25.png";